@if (data(); as msg) {
  <div class="d-flex align-items-center gap-2">
    <img
      class="rounded-circle"
      width="28"
      height="28"
      [src]="msg.avatar || CurrentUserModel.placeholderAvatarUrl"
      (error)="handleImageError($event)"
      alt="Updated avatar" />
    <span>{{ msg.userName || 'User' }} avatar updated.</span>
  </div>
}